import { assign } from './../../../../lib';
import config from './config.json';

const getConfig = env => {
  return assign({}, env === 'production' ? config.production : config.default);
};

export default getConfig;
